import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private static matDialog: MatDialog;

  constructor(dialog: MatDialog) {
    DialogService.matDialog = dialog;
  }

  static getDialog(): MatDialog {
    return this.matDialog;
  }
}
